"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const utilities_1 = require("../../Themes/utilities");
const Wrapper = styled_components_1.default.div `
  height: 100%;
  ${utilities_1.mb('s')} {
    position: relative;
  }
  flex-shrink: 0;

  ${({ position }) => position === 'right'
    ? styled_components_1.css `
          ${utilities_1.mb('xs')} {
            :last-child {
              margin-right: ${polished_1.rem(4)};
            }
          }
        `
    : styled_components_1.css `
          ${utilities_1.mb('xs')} {
            :first-child {
              margin-left: ${polished_1.rem(4)};
            }
          }
        `}
`;
const Dropdown = styled_components_1.default.div `
  z-index: 51;
  position: absolute;
  background-color: ${({ theme }) => theme.backgroundColor};

  top: ${polished_1.rem(48)};
  left: 0;
  right: 0;
  bottom: 0;

  /* ugly hack so status bar shadow is visible */
  overflow: hidden;
  ::before {
    content: '';
    position: absolute;
    top: -1px;
    right: 0;
    left: 0;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    height: 1px;
  }

  ${utilities_1.mb('s')} {
    ::before {
      content: none;
    }
    top: ${polished_1.rem(54)};
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
    border-radius: ${({ theme }) => theme.largeBorderRadius};
    bottom: auto;
    width: ${({ dropdownWidth }) => polished_1.rem(dropdownWidth)};
    ${({ position }) => position === 'right'
    ? styled_components_1.css `
            right: 0;
            left: auto;
          `
    : styled_components_1.css `
            left: 0;
            right: auto;
          `}
  }
`;
const StatusBarDropdown = ({ className, position = 'left', width = 288, children, body, opened, onClose, }) => {
    const wrapperEl = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        if (!opened) {
            return;
        }
        const handleClickOutside = (e) => {
            var _a;
            if (!((_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                onClose();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [opened, onClose]);
    return (react_1.default.createElement(Wrapper, { className: className, ref: wrapperEl, position: position },
        children,
        opened && (react_1.default.createElement(Dropdown, { position: position, dropdownWidth: width }, body))));
};
exports.default = StatusBarDropdown;
